export const USER_TYPES = {
  ADULT: 'adult',
  CHILD: 'child'
} as const;

export type UserType = typeof USER_TYPES[keyof typeof USER_TYPES];

export function normalizeUserType(value: unknown): UserType {
  return value === USER_TYPES.CHILD ? USER_TYPES.CHILD : USER_TYPES.ADULT;
}

export function isAdultUserType(value: unknown): boolean {
  return normalizeUserType(value) === USER_TYPES.ADULT;
}
